import { makeStyles } from '@material-ui/core';
import { rgba } from 'polished';

export default makeStyles((theme) => ({
  selectItemTitle: {
    color: rgba(theme.palette.primary.contrastText, 0.8),
    paddingLeft: 8,
  },
}));
